<template>
    <div>
        <legend>Клиент: <span class="pl-2 pr-2">{{partner.Reception}}</span> / <span class="pl-2">{{partner.Tour.Name}}</span></legend>
        <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
                <router-link class="nav-link"
                             :to="{ name: 'partner', params: {id: $route.params.id}}">
                    Информация
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link"
                             :to="{ name: 'customer-orders', params: {id: $route.params.id}}">
                    Заказы
                </router-link>
            </li>
        </ul>
        <router-view/>
    </div>
</template>
<script>

import { get, put } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/customer`;

export default {
  components: {},
  data() {
    return {
      partner: [],
      partnerTours: [],
      partnerPriceLists: [],
      dispatchDays: [],
      cities: [],
    };
  },
  async created() {
    await this.fetchPartner();
    // await this.fetchPartnerTours();
    // await this.fetchPartnerPriceLists();
    // await this.fetchDispatchDays();
    // await this.fetchCities();
  },
  methods: {
    async fetchPartner() {
      const { data } = await get(`${url}/${this.$route.params.id}`);
      this.partner = data;
    },
    async fetchPartnerTours() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/tour/${this.partner.PartnerGroupId}`);
      this.partnerTours = data.data;
    },
    async fetchPartnerPriceLists() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/price-list/${this.partner.PartnerGroupId}`);
      this.partnerPriceLists = data.data;
    },
    async fetchDispatchDays() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-add-form/dispatch-days`);
      this.dispatchDays = data;
    },
    async fetchCities() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/city`);
      this.cities = data;
    },
    async submit() {
      await put(`${process.env.VUE_APP_API_HOST}admin/partner`, this.partner);
      this.$toasted.show('Партнер сохранен!', { type: 'success' });
      await this.fetchPartner();
    },
  },
};
</script>
